import { STORE_ID } from '../constants'
import type { Template } from '../entities/Template'

export const useTemplateStore = () => {
  const state = useState<Template>(STORE_ID, () => ({
    header: {
      showMenu: true,
      showShare: false,
      showPopover: false,
      showMenuPrivate: false,
      showPublicMenu: false,
    },
  }))

  const getTemplate: Ref<Template> = computed(() => state.value)
  const setTemplate = (template: Template) => {
    state.value.header.showMenu = template.header.showMenu
    state.value.header.showShare = template.header.showShare
    state.value.header.showPopover = template.header.showPopover
    state.value.header.showMenuPrivate = template.header.showMenuPrivate
    state.value.header.showPublicMenu = template.header.showPublicMenu
  }
  const setHeaderShowPopover = (value: boolean | undefined) => {
    state.value.header.showPopover = value || false
  }

  return {
    getTemplate,
    setTemplate,
    setHeaderShowPopover,
  }
}
